import { useEditIndicators } from '../hooks/useEditIndicators';

export const EditGeneralIndicators = () => {
	const { getComponent } = useEditIndicators({ isGeneralIndicator: true });

	return getComponent();
};
